import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';

export function useAuth() {
  const { 
    user, 
    session, 
    isLoading, 
    error,
    initialize,
    signIn, 
    signUp, 
    signOut, 
    resetPassword,
    clearError 
  } = useAuthStore();

  useEffect(() => {
    initialize();
  }, [initialize]);

  return {
    user,
    session,
    isLoading,
    error,
    isAuthenticated: !!session,
    signIn,
    signUp,
    signOut,
    resetPassword,
    clearError,
  };
}
